export default __webpack_public_path__ + "static/Merriweather-Italic-600701225717b7bb07bfebdb41c1a796.woff";